<app-header></app-header>

<div class="min-h-screen tema-claro">
  <div class="max-w-5xl mx-auto p-6">

    <!-- Breadcrumb / Header -->
    <div class="mb-6 flex items-center gap-2 text-xs" style="color: var(--tx-2)">
      <a routerLink="/home" class="hover:underline" style="color: var(--brand-primary)">Início</a>
      <span>/</span>
      <span class="font-semibold" style="color: var(--tx)">Lançamentos Financeiros</span>
    </div>

    <!-- Page title -->
    <div class="mb-8">
      <h1 class="text-2xl font-semibold" style="color: var(--tx)">Lançamentos Financeiros</h1>
      <p class="text-sm mt-1" style="color: var(--tx-2)">
        Selecione o tipo de lançamento que deseja realizar.
      </p>
    </div>

    <!-- Cards -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

      <!-- Sangria card -->
      <button (click)="abrirSangria()"
              class="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition overflow-hidden text-left"
              style="border: 1px solid var(--flua-borda)">
        <div class="px-6 py-5 flex items-center gap-3" style="background-color: var(--thead)">
          <div class="w-10 h-10 rounded-full flex items-center justify-center" style="background-color: rgba(255,255,255,0.2)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="1.5" stroke="white" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"/>
            </svg>
          </div>
          <h2 class="text-base font-semibold text-white">Sangria</h2>
        </div>
        <div class="px-6 py-5">
          <p class="text-sm leading-relaxed" style="color: var(--tx-2)">
            Transferência de valores entre caixas da mesma unidade.
          </p>
          <div class="mt-4 flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
            <span>Abrir</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4 transition-transform group-hover:translate-x-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </div>
        </div>
      </button>

      <!-- Estacionamento card -->
      <button (click)="abrirEstacionamento()"
              class="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition overflow-hidden text-left"
              style="border: 1px solid var(--flua-borda)">
        <div class="px-6 py-5 flex items-center gap-3" style="background-color: var(--thead)">
          <div class="w-10 h-10 rounded-full flex items-center justify-center" style="background-color: rgba(255,255,255,0.2)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="1.5" stroke="white" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"/>
            </svg>
          </div>
          <h2 class="text-base font-semibold text-white">Estacionamento</h2>
        </div>
        <div class="px-6 py-5">
          <p class="text-sm leading-relaxed" style="color: var(--tx-2)">
            Registro de recebimentos por estacionamento médico.
          </p>
          <div class="mt-4 flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
            <span>Abrir</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4 transition-transform group-hover:translate-x-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </div>
        </div>
      </button>

      <!-- Histórico card -->
      <button (click)="abrirHistorico()"
              class="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition overflow-hidden text-left"
              style="border: 1px solid var(--flua-borda)">
        <div class="px-6 py-5 flex items-center gap-3" style="background-color: var(--thead)">
          <div class="w-10 h-10 rounded-full flex items-center justify-center" style="background-color: rgba(255,255,255,0.2)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="1.5" stroke="white" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
          </div>
          <h2 class="text-base font-semibold text-white">Histórico</h2>
        </div>
        <div class="px-6 py-5">
          <p class="text-sm leading-relaxed" style="color: var(--tx-2)">
            Consulta de recebimentos em espécie por saldo do caixa.
          </p>
          <div class="mt-4 flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
            <span>Abrir</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4 transition-transform group-hover:translate-x-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </div>
        </div>
      </button>

      <button *ngIf="hasCaixaAccess && avulsoLiberado" (click)="abrirPagamentoAvulso()"
              class="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition overflow-hidden text-left"
              style="border: 1px solid var(--flua-borda)">
        <div class="px-6 py-5 flex items-center gap-3" style="background-color: var(--thead)">
          <div class="w-10 h-10 rounded-full flex items-center justify-center" style="background-color: rgba(255,255,255,0.2)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="1.5" stroke="white" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"/>
            </svg>
          </div>
          <h2 class="text-base font-semibold text-white">Pagamento Avulso</h2>
        </div>
        <div class="px-6 py-5">
          <p class="text-sm leading-relaxed" style="color: var(--tx-2)">
            Recebimento de adiantamento sem agendamento ou atendimento aberto.
          </p>
          <div class="mt-4 flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
            <span>Abrir</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4 transition-transform group-hover:translate-x-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </div>
        </div>
      </button>

      <!-- Análise de Caixas (supervisor) -->
      <button *ngIf="isSupervisor" (click)="abrirAnaliseCaixas()"
              class="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition overflow-hidden text-left"
              style="border: 1px solid var(--flua-borda)">
        <div class="px-6 py-5 flex items-center gap-3" style="background-color: var(--thead)">
          <div class="w-10 h-10 rounded-full flex items-center justify-center" style="background-color: rgba(255,255,255,0.2)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="1.5" stroke="white" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"/>
            </svg>
          </div>
          <h2 class="text-base font-semibold text-white">Análise de Caixas</h2>
        </div>
        <div class="px-6 py-5">
          <p class="text-sm leading-relaxed" style="color: var(--tx-2)">
            Visão geral dos saldos por unidade com alertas de sangria e fechamento.
          </p>
          <div class="mt-4 flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
            <span>Abrir</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4 transition-transform group-hover:translate-x-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </div>
        </div>
      </button>

      <!-- Análise de Pendências (supervisor) -->
      <button *ngIf="isSupervisor" (click)="abrirAnalisePendencias()"
              class="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition overflow-hidden text-left"
              style="border: 1px solid var(--flua-borda)">
        <div class="px-6 py-5 flex items-center gap-3" style="background-color: var(--thead)">
          <div class="w-10 h-10 rounded-full flex items-center justify-center" style="background-color: rgba(255,255,255,0.2)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="1.5" stroke="white" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
            </svg>
          </div>
          <h2 class="text-base font-semibold text-white">Análise de Pendências</h2>
        </div>
        <div class="px-6 py-5">
          <p class="text-sm leading-relaxed" style="color: var(--tx-2)">
            Contas provisórias, com saldo pendente ou sem NF / Título.
          </p>
          <div class="mt-4 flex items-center gap-1 text-xs font-semibold" style="color: var(--brand-primary)">
            <span>Abrir</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke-width="2" stroke="currentColor" class="size-4 transition-transform group-hover:translate-x-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
            </svg>
          </div>
        </div>
      </button>

    </div>
  </div>
</div>
